import styled from 'styled-components';

export const HeroContainer = styled.div`
	min-height: 100vh;
	height: 100vh;
	display: flex;
	align-items: center;
	font-weight: 400;
	z-index: -1;
	padding: 20px;

	@media screen and (max-width: 800px) {
		padding: 20px 60px;
	}

	@media screen and (max-width: 600px) {
		padding: 20px;
	}
`;

export const HeroHeader = styled.h1`
	width: 100%;
	font-size: 3.5rem;
	font-weight: 700;
	margin-bottom: 3.2rem;
	text-align: center;

	@media screen and (max-width: 1400px) {
		text-align: center;
	}

	@media screen and (max-width: 1000px) {
		font-size: 2.8rem;
		padding-top: unset;
	}
`;
